import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import './JobSeekerNavbar.css';
import Logo from '../Images/GudnetNewLogo.webp'
import BaseUrl from '../../ApiServices/BaseUrl';

const AgencyNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setIsLoggedIn(true);
      setUserName(user.first_name || "Agency");
      setUserId(user.id || "");
    }
  }, []);

  useEffect(() => {
    if (!userId) return;

    let isMounted = true;
    const fetchUnreadCount = async () => {
      try {
        const response = await fetch(`${BaseUrl}/message/unread-count/agency/${userId}`);
        if (!response.ok) return;
        const data = await response.json();
        if (isMounted) {
          setUnreadMessageCount(Number(data?.unread_count || 0));
        }
      } catch (err) {
        console.error("Failed to fetch agency unread message count:", err);
      }
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 10000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [userId]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of the system.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, log me out!'
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("user");
        localStorage.removeItem("userId");
        localStorage.removeItem("userPlan");
        localStorage.removeItem("userStartDate");
        localStorage.removeItem("userEnddate");
        setIsLoggedIn(false);
        navigate("/");
        Swal.fire(
          'Logged Out!',
          'You have been successfully logged out.',
          'success'
        );
      }
    });
  };

  const handleMyAccount = () => navigate("/a-myaccount");
  const handleViewEmployees = () => navigate("/a-viewcandidates");
  const handleJobposting = () => navigate("/a-jobposting");
  const handleAppliedcandidate = () => navigate("/agencyappliedcandidates");
  const handleAddemployee = () => navigate("/addjobseeker");
  const handlesubscription = () => navigate("/a-jobsubscriptionplans");
  const handleEnquiry = () => navigate("/agency-enquiries");
  const handleSendAlert = () => navigate("/agency-send-alert");

  const isActive = (path) => location.pathname === path;

  const isProfileActive = ["/", "/myaccount", "/add-employee", "/employees", "/manage-jobs"].includes(location.pathname);

  return (
    <Navbar expand="xl" bg="white" variant="light" fixed="top" className="shadow-sm py-2 custom-navbar">
      <Container>
        <Navbar.Brand
          className="d-flex align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/agencydashboard")}
        >
          <img
            src={Logo}
            alt="Gudnet Logo" className="guflfworker-logo"
            style={{ height: '50px', objectFit: 'contain' }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="mx-auto nav-links">
            <Nav.Link
              href="/agencydashboard"
              className={isActive("/agencydashboard") ? "active-nav" : "nav-link-custom"}
            >
              DASHBOARD
            </Nav.Link>
            <Nav.Link
              href="/a-viewcandidates"
              className={isActive("/a-viewcandidates") ? "active-nav" : "nav-link-custom"}
              onClick={handleViewEmployees}
            >
              VIEW CANDIDATES
            </Nav.Link>
            <Nav.Link
              href="/agencyappliedcandidates"
              className={isActive("/agencyappliedcandidates") ? "active-nav" : "nav-link-custom"}
              onClick={handleAppliedcandidate}
            >
              APPLIED CANDIDATES
            </Nav.Link>
            <Nav.Link
              href="/a-jobposting"
              className={isActive("/a-jobposting") ? "active-nav" : "nav-link-custom"}
              onClick={handleJobposting}
            >
              MANAGE JOBS
            </Nav.Link>
            <Nav.Link
              href="/addjobseeker"
              className={isActive("/addjobseeker") ? "active-nav" : "nav-link-custom"}
              onClick={handleAddemployee}
            >
              ADD EMPLOYEES
            </Nav.Link>

            <Nav.Link
              href="/agency-messages"
              className={isActive("/agency-messages") ? "active-nav" : "nav-link-custom"}
              onClick={() => navigate("/agency-messages")}
            >
              <span className="messages-nav-link">
                MESSAGES
                {unreadMessageCount > 0 && (
                  <span className="messages-unread-badge">{unreadMessageCount}</span>
                )}
              </span>
            </Nav.Link>

            <NavDropdown
              title="SUBSCRIPTION"
              id="info-dropdown"
              className="news-dropdown subscription-dropdown"
            >
              <NavDropdown.Item href="/a-jobsubscriptionplans">JOB & CANDIDATE POSTING SUBSCRIPTION</NavDropdown.Item>
              <NavDropdown.Item href="/a-subscriptionplans">CANDIDATE CONTACT SUBSCRIPTION</NavDropdown.Item>
            </NavDropdown>

            {/* ✅ Updated Dropdown Menu with complete content */}
            <NavDropdown title="CONTACT US" id="info-dropdown" className="news-dropdown">
              <NavDropdown.Item href="/agency-aboutus">About Us</NavDropdown.Item>
              <NavDropdown.Item href="/agency-contactus">Contact Us</NavDropdown.Item>
              <NavDropdown.Item href="/agency-tips-news">Tips & News</NavDropdown.Item>
              <NavDropdown.Item href="/agency-training">Training</NavDropdown.Item>
              <NavDropdown.Item href="/agency-faqs">FAQs</NavDropdown.Item>
              <NavDropdown.Item href="/agency-terms-and-conditions">Terms & Conditions</NavDropdown.Item>
              <NavDropdown.Item href="/agency-privacy-policy">Privacy Policy</NavDropdown.Item>
              <NavDropdown.Item href="/agency-returns-refunds-cancellation">
                Returns, Refunds & Cancellation Policy
              </NavDropdown.Item>
              <NavDropdown.Item href="/agency-shipping-delivery-policy">
                Shipping & Delivery Policy
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          <div className="navbar-buttons d-flex flex-column gap-2">
            <NavDropdown
              title={
                <>
                  <i className="bi bi-person-circle me-1"></i> {userName}
                </>
              }
              id="profile-dropdown"
              className={`fw-semibold px-3 ${isProfileActive ? "active-nav" : ""}`}
            >
              <NavDropdown.Item
                onClick={handleMyAccount}
                className={isActive("/a-myaccount") ? "active-dropdown-item" : ""}
              >
                MY ACCOUNT
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={handleEnquiry}
                className={isActive("/agency-enquiries") ? "active-dropdown-item" : ""}
              >
                MY ENQUIRIES
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={handleSendAlert}
                className={isActive("/agency-send-alert") ? "active-dropdown-item" : ""}
              >
                SEND BULK MESSAGES
              </NavDropdown.Item>
              <NavDropdown.Divider />

              <NavDropdown.Item
                onClick={handleLogout}
                className="d-flex align-items-center text-danger"
              >
                <i className="bi bi-box-arrow-right me-2"></i> Logout
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AgencyNavbar;
